import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Card } from "flowbite-react";

const testimonials = [
    {
        quote: "I have been using Aryaa Dosa and Idli mix ever since I arrived in the UAE. I have tried many different Dosa mixes, but nothing comes close to this quality and taste.",
        author: "House Wife, Dubai",
        occupation: "Cook",
        img: "/p1.jpg",
    },
    {
        quote: "name1",
        author: "Name1",
        occupation: "food",
        img: "/p1.jpg",
    },
    {
        quote: "name2",
        author: "Name2",
        occupation: "food",
        img: "/p10.jpg",
    },
    {
        quote: "name3",
        author: "Name3",
        occupation: "food3",
        img: "/p9.jpg",
    },
    {
        quote: "name4",
        author: "Name4",
        occupation: "food3",
        img: "/p8.jpg",
    },
    {
        quote: "name5",
        author: "Name5",
        occupation: "food5",
        img: "/p7.jpg",
    },
    {
        quote: "name6",
        author: "Name6",
        occupation: "food6",
        img: "/p6.jpg",
    },
    {
        quote: "name7",
        author: "Name7",
        occupation: "food7",
        img: "/p5.jpg",
    },
    {
        quote: "name8",
        author: "Name8",
        occupation: "food8",
        img: "/p4.jpg",
    },
    {
        quote: "name9",
        author: "Name9",
        occupation: "food9",
        img: "/p3.jpg",
    },
    {
        quote: "name10",
        author: "Name10",
        occupation: "food10",
        img: "/p2.jpg",
    },
];

const Mapreview = ({ className = "" }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
    };

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
    };

    const handleImageClick = (index) => {
        setCurrentIndex(index);
    };

    const currentTestimonial = testimonials[currentIndex];

    return (
        <>
<div className={`w-[800px] flex-row items-center justify-center sm:px-0 box-border max-w-full text-center text-darkslategray-200 hidden lg:flex ${className}`}>
                    <div className="flex-1 flex flex-col items-center justify-start pt-[14px] pb-[14px] pr-[20px] pl-[20px] box-border relative gap-[3px] min-w-[268px] max-w-full">
                    <div className="w-[1118.8px] h-[521.8px] absolute right-[-359.8px]">
                        <img
                            className="top-[270px] left-[270px] feedback"
                            loading="lazy"
                            src={testimonials[1].img}
                            onClick={() => handleImageClick(1)}
                        />
                        <img
                            className="top-[114px] left-[742px] feedback"
                            loading="lazy"
                            src={testimonials[2].img}
                            onClick={() => handleImageClick(2)}
                        />
                        <img
                            className="top-[184px] left-[853px] feedback"
                            loading="lazy"
                            src={testimonials[3].img}
                            onClick={() => handleImageClick(3)}
                        />
                        <img
                            className="top-[409px] left-[287px] feedback"
                            loading="lazy"
                            src={testimonials[4].img}
                            onClick={() => handleImageClick(4)}
                        />
                        <img
                            className="top-[80px] left-[179px] feedback"
                            loading="lazy"
                            src={testimonials[5].img}
                            onClick={() => handleImageClick(5)}
                        />
                        <img
                            className="top-[214px] left-[681px] feedback"
                            loading="lazy"
                            src={testimonials[6].img}
                            onClick={() => handleImageClick(6)}
                        />
                        <img
                            className="top-[208px] left-[194px] feedback"
                            loading="lazy"
                            src={testimonials[7].img}
                            onClick={() => handleImageClick(7)}
                        />
                        <img
                            className="top-[70px] right-[194px] feedback"
                            loading="lazy"
                            src={testimonials[8].img}
                            onClick={() => handleImageClick(8)}
                        />
                        <img
                            className="top-[400px] right-[70px] feedback"
                            loading="lazy"
                            src={testimonials[9].img}
                            onClick={() => handleImageClick(9)}
                        />
                        <img
                            className="top-[30px] left-[400px] feedback"
                            loading="lazy"
                            src={testimonials[10].img}
                            onClick={() => handleImageClick(10)}
                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-col justify-center items-center min-h-screen">
                <div className="w-[414px] flex flex-row justify-center items-center py-3 px-5 box-border max-w-full">
                <div className="h-[100px] w-[100px] bg-white border-[3px] border-solid border-gray-500 rounded-full overflow-hidden flex items-center justify-center relative z-[2]">
    <div className="h-[100px] w-[100px] flex items-center justify-center">
        <img
            className="h-full w-full object-cover"
            alt=""
            src={testimonials[currentIndex].img}
        />
    </div>
</div>
                </div>
                <Card
                    className="relative text-center min-h-[150px] min-w-[400px] sm:min-w-[400px] max-w-[400px] leading-none glass-effect text-gray-400" style={{ backgroundColor: 'rgba(4, 66, 14, 0.226)' }}>
                    <h3 className='text-[15px] leading-tight'>
                        {currentTestimonial.quote}
                    </h3>
                    <h4 className='text-[13px]'>
                        {currentTestimonial.author}
                    </h4>
                    <h4 className='text-[15px]'>
                        {currentTestimonial.occupation}
                    </h4>
                    <button className="prev-button top-1/2 transform -translate-y-1/2 px-4 py-2 text-2xl text-black rounded-full lg:hidden" onClick={prevSlide}>❮</button>
                    <button className="next-button top-1/2 transform -translate-y-1/2 px-4 py-2 text-2xl text-black rounded-full lg:hidden" onClick={nextSlide}>❯</button>
                </Card>
            </div>
        </>
    );
};

Mapreview.propTypes = {
    className: PropTypes.string,
};

export default Mapreview;